import { render, staticRenderFns } from "./ScaryButton.vue?vue&type=template&id=5bad925a&scoped=true&"
import script from "./ScaryButton.vue?vue&type=script&lang=js&"
export * from "./ScaryButton.vue?vue&type=script&lang=js&"
import style0 from "./ScaryButton.vue?vue&type=style&index=0&id=5bad925a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad925a",
  null
  
)

component.options.__file = "ScaryButton.vue"
export default component.exports